import { render } from "./ScrollableCommonTable.vue?vue&type=template&id=65d67edc&scoped=true"
import script from "./ScrollableCommonTable.vue?vue&type=script&lang=js"
export * from "./ScrollableCommonTable.vue?vue&type=script&lang=js"

import "./ScrollableCommonTable.vue?vue&type=style&index=0&id=65d67edc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65d67edc"]])

export default __exports__